module.exports = __webpack_public_path__ + "static/media/puff-familiar.cbcb311c.png";